

function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

Object.defineProperty(exports,'__esModule',{value:true});var Cookies=require('js-cookie'),React=require('react');function _interopDefaultLegacy(e){return e&&typeof e==='object'&&'default'in e?e:{'default':e}}var Cookies__default=/*#__PURE__*/_interopDefaultLegacy(Cookies);var React__default=/*#__PURE__*/_interopDefaultLegacy(React);var isProductionHostname = function () {
    var hostname = window.location.hostname;
    return /^(www2|www|investor)\.(intra\.|partners\.)?storebrand\.no$|^pr\.stb\.intra$/.test(hostname);
};
function getVersionFromWindowLocation() {
    if (isProductionHostname()) {
        return "active";
    }
    return "pending";
}
function getVersion() {
    var _a;
    var versionFromIwaCli = (_a = window.env) === null || _a === void 0 ? void 0 : _a.TRANSLATION_VERSION;
    if (versionFromIwaCli) {
        return versionFromIwaCli;
    }
    return getVersionFromWindowLocation();
}
function getInitialLanguage() {
    var language = Cookies__default["default"].get("lang");
    return language || "no";
}
function getCookieDomain() {
    return process.env.NODE_ENV === "development"
        ? location.hostname
        : ".storebrand.no";
}var TranslationContext = React.createContext(null);/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}var keyExistsForLanguage = function (key, translations, language) {
    var _a;
    var languageTranslations = (_a = translations === null || translations === void 0 ? void 0 : translations[language]) !== null && _a !== void 0 ? _a : {};
    return key in languageTranslations;
};var getFMSValue = function (key, translations, language) {
    return keyExistsForLanguage(key, translations, language)
        ? translations[language][key]
        : null;
};var insertValue = function (text, data) {
    return text.replace(/\{(.*?)\}/g, function (placeholder) {
        var value = data[placeholder.substring(1, placeholder.length - 1)];
        if (value !== null && value !== undefined) {
            return value.toString();
        }
        return "-";
    });
};var hasMissingKey = function (textOptions) { var _a; return ((_a = textOptions) === null || _a === void 0 ? void 0 : _a.onMissingKey) !== undefined; };
var hasInsert = function (textOptions) { var _a; return ((_a = textOptions) === null || _a === void 0 ? void 0 : _a.insert) !== undefined; };var getText = function (key, translations, language, options) {
    if (keyExistsForLanguage(key, translations, language)) {
        var fmsValue = getFMSValue(key, translations, language);
        if (hasInsert(options)) {
            return insertValue(fmsValue, options.insert);
        }
        return fmsValue;
    }
    if (hasMissingKey(options)) {
        return options.onMissingKey();
    }
    return "??".concat(key, "??");
};var getJSON = function (key, translations, language) {
    var fmsJsonValue = getFMSValue(key, translations, language);
    return fmsJsonValue || {};
};var setLanguageInCookie = function (newLanguage, currentLanguage) {
    var newCustomerLanguage = newLanguage === "en" ? "ENGLISH" : "NORWEGIAN";
    var oldCustomerLanguage = currentLanguage === "en" ? "ENGLISH" : "NORWEGIAN";
    if (newCustomerLanguage !== oldCustomerLanguage) {
        Cookies__default["default"].set("lang", newLanguage, {
            path: "/",
            domain: getCookieDomain(),
        });
    }
};var sendNewLanguageToServer = function (newLanguage, currentLanguage) {
    var newCustomerLanguage = newLanguage === "en" ? "ENGLISH" : "NORWEGIAN";
    var oldCustomerLanguage = currentLanguage === "en" ? "ENGLISH" : "NORWEGIAN";
    if (newCustomerLanguage !== oldCustomerLanguage) {
        fetch("/customer/core-data", {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ language: newCustomerLanguage }),
        });
    }
};var fetchLanguageDocuments = function (document, lang, clientId, version) {
    var documentsToFetch = Array.isArray(document) ? document : [document];
    return Promise.all(documentsToFetch.map(function (documentName) {
        return fetchLanguageDocument(lang, documentName, clientId, version);
    })).then(function (loadedTranslations) {
        return Object.assign.apply(Object, __spreadArray([{}], loadedTranslations, false));
    });
};
var fetchLanguageDocument = function (lang, documentName, clientId, version) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        url = "https://api.storebrand.no/open/content/texts/".concat(documentName, "?version=").concat(version, "&lang=").concat(lang);
        return [2, fetch(url, {
                method: "GET",
                headers: { clientId: clientId },
            }).then(function (response) { return response.json(); })];
    });
}); };var updateHtmlWithNewLanguage = function (language) {
    var _a;
    (_a = document.querySelector("html")) === null || _a === void 0 ? void 0 : _a.setAttribute("lang", language);
};var TranslationProvider = function (_a) {
    var clientId = _a.clientId, document = _a.document, children = _a.children, fallback = _a.fallback;
    var version = getVersion();
    var _b = React.useState(getInitialLanguage()), language = _b[0], setLanguage = _b[1];
    var _c = React.useState([]), fetchedLanguages = _c[0], setFetchedLanguages = _c[1];
    var _d = React.useState(fallback), translations = _d[0], setTranslations = _d[1];
    var _e = React.useState(true), loading = _e[0], setLoading = _e[1];
    var fetchLanguage = React.useCallback(function (lang) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (fetchedLanguages.includes(lang)) {
                setLanguage(lang);
                return [2];
            }
            setLoading(true);
            fetchLanguageDocuments(document, lang, clientId, version)
                .then(function (newTranslations) {
                var _a;
                setTranslations(__assign(__assign({}, translations), (_a = {}, _a[lang] = newTranslations, _a)));
            })
                .catch(function () {
                var _a;
                setTranslations(__assign(__assign({}, translations), (_a = {}, _a[lang] = fallback[lang], _a)));
            })
                .finally(function () {
                setLanguage(lang);
                setFetchedLanguages(__spreadArray(__spreadArray([], fetchedLanguages, true), [lang], false));
                setLoading(false);
            });
            return [2];
        });
    }); }, [document, clientId, version, fetchedLanguages, fallback, translations]);
    var providerValue = React.useMemo(function () { return ({
        translations: translations,
        language: language,
        changeLanguage: function (lang) {
            setLanguageInCookie(lang, language);
            sendNewLanguageToServer(lang, language);
            updateHtmlWithNewLanguage(lang);
            fetchLanguage(lang);
        },
        getText: function (key, options) {
            return getText(key, translations, language, options);
        },
        getJSON: function (key) { return getJSON(key, translations, language); },
        textsLoading: loading,
    }); }, [fetchLanguage, language, loading, translations]);
    React.useEffect(function () {
        fetchLanguage(language);
        updateHtmlWithNewLanguage(language);
    }, []);
    if (loading && !translations) {
        return null;
    }
    return (React__default["default"].createElement(TranslationContext.Provider, { value: providerValue }, children));
};function useTranslations() {
    return React.useContext(TranslationContext);
}exports.TranslationContext=TranslationContext;exports.TranslationProvider=TranslationProvider;exports.getCookieDomain=getCookieDomain;exports.getInitialLanguage=getInitialLanguage;exports.getVersion=getVersion;exports.useTranslations=useTranslations;//# sourceMappingURL=index.js.map
